module.exports = __webpack_public_path__ + "media/images/writer/monitor/sp-mv-img@3x-1738a11db278572c49b54fc416f7a327.png";